import { render, staticRenderFns } from "./ExampleBox.vue?vue&type=template&id=af55a12e&scoped=true&"
import script from "./ExampleBox.vue?vue&type=script&lang=js&"
export * from "./ExampleBox.vue?vue&type=script&lang=js&"
import style0 from "./ExampleBox.vue?vue&type=style&index=0&id=af55a12e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af55a12e",
  null
  
)

export default component.exports